import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const ImageStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Child element styles
  ------------------------------- */
  .image {
    width: 100%;
  }

  .__react_component_tooltip {
    padding: 5px 10px;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};

    &.show {
      opacity: 1;
    }

    &.background-white {
      background-color: white;
      box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.12) !important;
      border: 0 !important;
      color: ${VARIABLES.COLORS.GRAY_3};
      white-space: pre-line;

      &.place-bottom {
        border-bottom-color: white;

        &:after,
        &before {
          display: none;
        }
      }

      &.place-top {
        border-top-color: white;

        &:after,
        &before {
          display: none;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */
  &.cursor-icon {
    cursor: default;
  }

  &.supplier-sign {
    width: 24px;
  }

  &.padlock-icon {
    margin-left: 0.5em;
    width: 17px;
    height: 17px;
  }
  &.padlock-icon-center {
    margin: auto;
    width: 17px;
    height: 17px;
  }

  &.padlock-icon-company {
    margin-right: 10px;
    width: 17px;
    height: 17px;
  }

  &.wrong-icon {
    width: 16px;
  }

  /* config /supplier-registration-form when upload file attach */
  &.delete_company_profile {
    /* position: relative;
    right: 45px;
    bottom: 17px; */
  }

  &.icon-checked {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 15px;
    padding: 3px;
    background-color: ${VARIABLES.COLORS.GREEN_1};
    border-radius: 50%;
    margin-right: 10px;
  }

  &.icon-disabled {
    filter: grayscale(1) opacity(0.5);
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .__react_component_tooltip {
      padding: 5px 9px;
      font-size: 16px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .__react_component_tooltip {
      padding: 4px 8px;
      font-size: 15px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .__react_component_tooltip {
      padding: 4px 7px;
      font-size: 14px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .__react_component_tooltip {
      padding: 3px 6px;
      font-size: 13px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .__react_component_tooltip {
      padding: 3px 5px;
      font-size: 12px;
    }
  }
`
